export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const SET_USER = 'SET_USER';
export const TOGGLE_USER_SETTINGS = 'TOGGLE_USER_SETTINGS';
